module.exports = __webpack_public_path__ + "13c4ac8eb81d8cf1ebcf53797329abde.png";